import React, { createContext, useContext } from "react";
import {
  Dialog,
  DialogType,
  DialogFooter,
} from "@fluentui/react/lib/Dialog";
import { Button, Input, notification } from "antd";
import { ContextualMenu } from "@fluentui/react/lib/ContextualMenu";
import Form from "antd/lib/form/Form";
import { Formik } from "formik";
import { MailOutlined } from "@ant-design/icons";
import FormItem from "antd/lib/form/FormItem";
import { observer } from "mobx-react-lite";
import HomeStore from "../store/homestore";
import MainStore from "../store/mainStore";
import "../style/login.css";
import { PasswordResetValidationSchema } from "../../../Utility/Validations/HomeValidations";

const dragOptions = {
  moveMenuItemText: "Move",
  closeMenuItemText: "Close",
  menu: ContextualMenu,
};
const initFormData = { email: "" };
const modalPropsStyles = { main: { maxWidth: 600 } };

const dialogContentProps = {
  type: DialogType.normal,
  title: "Password Reset",
  subText:
    "Provide your SPARS username (work email) to enable us send your password reset to you via mail ",
};
const mainstore = createContext(MainStore);
export const ResetPassword = observer(() => {
  const homeStore = useContext(HomeStore);
  const mainStore = useContext(mainstore);
  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: dragOptions,
    }),
    []
  );
  return (
    <Dialog
      hidden={!homeStore.showpasswordResetDialog}
      onDismiss={() => {
        homeStore.showpasswordResetDialog = false;
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      minWidth={400}
    >
      <Formik
        initialValues={initFormData}
        validationSchema={PasswordResetValidationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          console.log(values);
          try {
            const retVal = await mainStore.resetPassword(values.email);
            if (retVal.success) {
              notification.success({
                message: "SPARS Feedback",
                description:
                  "Password reset successfull with notifications to your email",
              });
              homeStore.showpasswordResetDialog = false;
            } else {
              notification.error({
                message: "SPARS Feedback",
                description:
                  "Sorry, your record does not exit,request for an account",
              });
            }
          } catch (error) {
            notification.error({
              key: "error",
              message: "SPARS Feedback",
              description: error.message,
            });
          }
        }}
        validate={(values) => {
          let errors = {};

          return errors;
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,

          handleSubmit,
          isSubmitting,
        }) => (
          <Form layout="vertical" onFinish={handleSubmit}>
            <FormItem
              label="UserName (Work Email)"
              required
              help={touched.email && errors.email}
            >
              <Input
                placeholder="Enter a valid work email for verification"
                name="email"
                value={values.email}
                onChange={handleChange}
                allowClear
                prefix={<MailOutlined style={{ color: "#A0AEC0" }} />}
              />
            </FormItem>
            <DialogFooter>
              <Button
                type="link"
                onClick={() => {
                  homeStore.showpasswordResetDialog = false;
                }}
              >
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={isSubmitting}>
                Reset
              </Button>
            </DialogFooter>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
});

